import {
  data,
  data2,
} from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/data';
import { StationArbeitsbereichCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/StationArbeitsbereichCard';
import { StationMitarbeiterCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/StationMitarbeiterCard';
import { useKalenderContext } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/KalenderContext';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

export function Kalender({
  view,
}: {
  view: 'mitarbeiter' | 'arbeitsbereiche';
}) {
  const { currentStartOfWeek } = useKalenderContext();

  return (
    <div className="flex flex-col gap-4">
      {view === 'arbeitsbereiche'
        ? data2.map((arbeitsbereich) =>
            arbeitsbereich.stationen
              ?.filter(
                (station) =>
                  dayjs(station.von).isoWeek() <=
                    currentStartOfWeek.isoWeek() &&
                  dayjs(station.bis).isoWeek() >= currentStartOfWeek.isoWeek(),
              )
              .map((station) => {
                return (
                  <StationArbeitsbereichCard
                    key={station.id}
                    arbeitsbereich={arbeitsbereich}
                    station={station}
                  />
                );
              }),
          )
        : data.map((mitarbeiter) =>
            mitarbeiter.stationen
              ?.filter(
                (station) =>
                  dayjs(station.von).isoWeek() <=
                    currentStartOfWeek.isoWeek() &&
                  dayjs(station.bis).isoWeek() >= currentStartOfWeek.isoWeek(),
              )
              .map((station) => {
                return (
                  <StationMitarbeiterCard
                    key={station.id}
                    mitarbeiter={mitarbeiter}
                    station={station}
                  />
                );
              }),
          )}
    </div>
  );
}
